import { useCallback } from 'react';

import { useInterval } from 'react-use';

import { reload } from '@/services/feature-flags';

export const useFeatureFlagRefresh = (refreshInterval = 10000) => {
  const refreshFeatureFlag = useCallback(() => {
    reload();
  }, []);

  useInterval(refreshFeatureFlag, refreshInterval);
};
